import React, {useEffect, useState} from 'react';
import "./orderMainSectionComponent.scss";
import OrderMainDetails from "./components/OrderMainDetails";
import SearchedRealatedProduct from "./components/SearchedRealatedProduct";
import {useNavigate, useParams} from "react-router-dom";
import OrderMainFoodPath from "../orderMainFoodSection/components/OrderMainFoodPath";
import OrderHeadSectionComponent from "../../components/headSection/components/OrderHeadSectionComponent";
import ContactSectionComponent from "../../pages/main/sections/contactSection/ContactSectionComponent";
import {UseCreateDineInReservation, UseCreateTakeOutReservation} from "../../api/useReservation";
import {useSelector} from "react-redux";

const getCategoryName = (category: string) => {
    const words = category.split("-");
    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase() + words[0].slice(1);
    } else {
        const firstWord = words[0];
        const restOfWords = words.slice(1).join(" ");
        return firstWord.charAt(0).toUpperCase() + firstWord.slice(1) + " " + restOfWords;
    }
}

const OrderMainSectionComponent = () => {
    const {category, details, order} = useParams();
    const selectedOrder = {};//JSON.parse(localStorage.getItem("selectedOrder") as string);
    const acceptedOrderStore = JSON.parse(localStorage.getItem("acceptedOrder") as any);
    const [acceptedOrder, setAcceptedOrder] = useState<any>(/*JSON.parse(localStorage.getItem("acceptedOrder") || "{}")*/);
    const [acceptedTime, setAcceptedTime] = useState<any>(null);
    const navigate = useNavigate();
    const userIdStore = useSelector((state: any) => state.user.id);
    const userNameStore = useSelector((state: any) => state.user.name);


    const acceptOrder = (order: any) => {
        console.log("order: ", order);
        setAcceptedOrder(order);
        //localStorage.setItem("acceptedOrder", JSON.stringify(order));
        const selectedUserInfo: any = JSON.parse(localStorage.getItem("selectedUserInfo") as any);
        //console.log("selectedUserInfo: ", selectedUserInfo, userIdStore, order.isDineIn);
        if (order.isDineIn && selectedUserInfo && userIdStore) {
            const dineInReservationObj = {
                guestsNr: selectedUserInfo.guestsNr,
                reservationTime: selectedUserInfo.time,
                reservationName: selectedUserInfo.name,
                dineInAdId: order.data._id,
                userId: userIdStore,
            }
            UseCreateDineInReservation(dineInReservationObj).then((response: any) => {
                console.log("UseDineInReservation response: ", response);
                //localStorage.setItem("acceptedDineInReservationId", response.result._id);
                // navigate(`/food/${category}/${details}/accept-order`);
                navigate(`/cart/${response.result._id}/accept-order`);
            })
        }
        if (!order.isDineIn && selectedUserInfo && userIdStore) {
            const takeOutReservationObj = {
                reservationTime: selectedUserInfo.time,
                reservationName: userNameStore,
                mealsNr: 1,
                takeOutAdId: order.data._id,
                userId: userIdStore,
            }
            UseCreateTakeOutReservation(takeOutReservationObj).then((response: any) => {
                console.log("UseCreateTakeOutReservation response: ", response);
                //localStorage.setItem("acceptedTakeOutReservationId", response.result._id);
                // navigate(`/food/${category}/${details}/accept-order`);
                navigate(`/cart/${response.result._id}/accept-order`);
            })
        }

    }

    /*useEffect(() => {
        acceptedOrderStore && setAcceptedOrder(acceptedOrderStore);
    }, [acceptedOrderStore]);*/


    const acceptTime = (time: any) => {
        setAcceptedTime(time);
    }

    return (
        <>
            <OrderHeadSectionComponent />
            <div className="orderMainSectionComponent__container">
                <OrderMainFoodPath
                    path={["Food", category ? getCategoryName(category) : "", details ? getCategoryName(details) : ""]}
                    selectedCategory={category ? getCategoryName(category) : ""}
                />
                <OrderMainDetails
                    selectedOrder={selectedOrder}
                    acceptTime={acceptTime}
                    acceptOrder={acceptOrder}
                />
                <div className="orderMainSectionComponent__container-content-searched-realated-product">
                    <SearchedRealatedProduct />
                </div>
                <div className="orderMainSectionComponent__container-content-contact">
                    <ContactSectionComponent />
                </div>
            </div>
        </>
    );
};

export default OrderMainSectionComponent;